<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
      }
    },
    computed:{
      ...mapGetters([
        'authenticated'
      ])
    }
  }
</script>

<template>
  <div class="footer">
    &copy; 2025 evolution-skinonlinedevelopment.com
  </div>
</template>

<style lang="scss">
  .footer{
    text-align: center !important;
    background-color: rgba(0,0,0, 0.3);
    font-weight: bold;
    position: absolute;
    width: 100%;
    z-index: 2;
    bottom: 0%;
  }
</style>